import { render, staticRenderFns } from "./updateBulkPromotion.vue?vue&type=template&id=f8824ba2&scoped=true"
import script from "./updateBulkPromotion.vue?vue&type=script&lang=js"
export * from "./updateBulkPromotion.vue?vue&type=script&lang=js"
import style0 from "./updateBulkPromotion.vue?vue&type=style&index=0&id=f8824ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8824ba2",
  null
  
)

export default component.exports